export default __webpack_public_path__ + "static/media/wallet_status.e09c61f7.svg";